import moment from 'moment-timezone';

export const MONTHS = moment.months().map((month, index) => {
  return {
    label: month,
    value: index,
  };
});
